import { Context } from '@/models/order-history/status/context/context'
import { ForDefaultPaymentMethod } from '@spa/components/organisms/mypage/order/model/order-status-view/commands/for-default-payment-method'
import { ForExternalPayment } from '@spa/components/organisms/mypage/order/model/order-status-view/commands/for-external-payment-method'
import { ForNpPostpay } from '@spa/components/organisms/mypage/order/model/order-status-view/commands/for-np-postpay'
import { DeliveryIndicatorStatus } from '@spa/components/organisms/mypage/order/model/order-status-view/delivery-indicator'
import { VueConstructor } from 'vue'

export interface OrderStatusViewModel {
  label: string
  labelView: VueConstructor
  /**
   * TODO:
   * リスト用と詳細用を分ける必要があるか経緯を調査して検討する。
   * 既存の仕様ではリスト用で表示されているもののうち、「再注文の期限が過ぎたためキャンセルされました。」のみ詳細でも表示しているが、
   * 他のものも詳細で表示されていて問題ないように思える。
   */
  description: {
    forListView?: string
    forDetailView?: string
  }
  deliveryIndicatorStatus?: DeliveryIndicatorStatus
}

export function createOrderStatusViewModel(context: Context): OrderStatusViewModel {
  const forNpPostpay = new ForNpPostpay()
  if (forNpPostpay.shouldApply(context)) {
    return forNpPostpay.execute(context)
  }
  const forExternalPayment = new ForExternalPayment()
  if (forExternalPayment.shouldApply(context)) {
    return forExternalPayment.execute(context)
  }

  return new ForDefaultPaymentMethod().execute(context)
}
